import { authenticatedRequest } from './base.service';

export interface Salary {
  id: string;
  amount: number;
  currency: 'MXN' | 'USD' | 'EUR';
  frequency: 'monthly' | 'biweekly';
  type: 'base' | 'bonus' | 'commission' | 'overtime' | 'deduction';
  userId: string;
  organizationId: string;
  createdAt: string;
}

export interface CreateSalaryData {
  amount: number;
  currency?: 'MXN' | 'USD' | 'EUR';
  frequency?: 'monthly' | 'biweekly';
  type?: 'base' | 'bonus' | 'commission' | 'overtime' | 'deduction';
  userId: string;
}

export interface UpdateSalaryData {
  amount?: number;
  type?: 'base' | 'bonus' | 'commission' | 'overtime' | 'deduction';
}

const getToken = (): string => {
  const token = localStorage.getItem('finara_token');
  if (!token) throw new Error('No authentication token found');
  return token;
};

export const salariesService = {
  async createSalary(data: CreateSalaryData): Promise<Salary> {
    return authenticatedRequest<Salary>(
      '/api/v1/salaries',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      getToken()
    );
  },

  async getUserSalaries(userId: string): Promise<Salary[]> {
    return authenticatedRequest<Salary[]>(`/api/v1/salaries/user/${userId}`, {}, getToken());
  },

  async updateSalary(id: string, data: UpdateSalaryData): Promise<Salary> {
    return authenticatedRequest<Salary>(
      `/api/v1/salaries/${id}`,
      {
        method: 'PATCH',
        body: JSON.stringify(data),
      },
      getToken()
    );
  },

  async deleteSalary(id: string): Promise<void> {
    return authenticatedRequest<void>(
      `/api/v1/salaries/${id}`,
      {
        method: 'DELETE',
      },
      getToken()
    );
  },
};
